import {
  parseDate
} from "./chunk-KPPABCK2.mjs";

// src/date/week.ts
function startOfWeek(date, options) {
  const weekStartsOn = Math.min(Math.max((options == null ? void 0 : options.weekStartsOn) ?? 0, 0), 6);
  const d = typeof date === "string" ? parseDate(date) : date;
  const day = d.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
}
function endOfWeek(date, options) {
  const weekStartsOn = Math.min(Math.max((options == null ? void 0 : options.weekStartsOn) ?? 0, 0), 6);
  const d = typeof date === "string" ? parseDate(date) : date;
  const day = d.getDay();
  const diff = 6 - ((day < weekStartsOn ? 7 : 0) + day - weekStartsOn);
  d.setDate(d.getDate() + diff);
  d.setHours(23, 59, 59, 999);
  return d;
}

export {
  startOfWeek,
  endOfWeek
};
//# sourceMappingURL=chunk-TMLVJI4J.mjs.map